import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { getRelativePath } from "Utils";
import { getNextMenuRoute } from "Administrator/modules/AdministratorModule";
import LoginPageConfigurationSetup from "Administrator/routes/SchoolSetup/routes/LoginConfigurationManager/routes/LoginPageConfiguration";
import LoginOptionsConfigurationSetup from "Administrator/routes/SchoolSetup/routes/LoginConfigurationManager/routes/LoginOptionsConfiguration";
import MFAConfigurationSetup from "Administrator/routes/SchoolSetup/routes/LoginConfigurationManager/routes/MFAConfiguration";

export default store => ({
  path: "login-configuration",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(
        /* webpackChunkName: "login-configuration-manager" */ "./components"
      ),
      import(
        /* webpackChunkName: "login-configuration-manager" */ "./routes/LoginPageConfiguration/modules/LoginPageConfigurationModule"
      ),
      import(
        /* webpackChunkName: "login-configuration-manager" */ "./routes/LoginOptionsConfiguration/modules/LoginOptionsConfigurationModule"
      ),
    ])
      .then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const loginPageConfigurationReducer = importedModule1.default;
        const loginOptionsConfigurationReducer = importedModule2.default;

        injectReducer(store, {
          key: importedModule1.NAME,
          reducer: loginPageConfigurationReducer,
        });
        injectReducer(store, {
          key: importedModule2.NAME,
          reducer: loginOptionsConfigurationReducer,
        });

        return component;
      })
      .catch(err => {
        return err;
      })
  ),
  onEnter(nextState, replace) {
    if (_.last(nextState.routes).path == "login-configuration") {
      const route = getNextMenuRoute("LOGIN_CONFIGURATION");
      if (route) {
        replace(getRelativePath(route));
      } else {
        replace(getRelativePath("../"));
      }
    }
  },
  childRoutes: [
    LoginPageConfigurationSetup(store),
    LoginOptionsConfigurationSetup(store),
    MFAConfigurationSetup(store),
  ],
});
